import { render, staticRenderFns } from "./form-customer-select.vue?vue&type=template&id=7a04d50a&scoped=true"
import script from "./form-customer-select.vue?vue&type=script&setup=true&lang=js"
export * from "./form-customer-select.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a04d50a",
  null
  
)

export default component.exports